require('./bootstrap');
require('../js/webinar_live/nicepage');
require('../js/sendFormV2')

/* VENDOR */
require('jquery-mask-plugin');
require('select2');
/* CUSTOM */
require('./webinar_live/custom/controller');
